/**
 * Created by senani on 12/20/18.
 */

import React, {Component, Fragment} from 'react';
import './OrderItem Table.css';
import "../../../Common/ResponsiveOrderConfirmation.css";
import OrderItemRow from '../OrderItemRow/OrderItemRow';
import {FormattedMessage} from "react-intl";
import NumberFormatter from "../../../Common/NumberFormatter/NumberFormatter";
import No_Image from "../../../../assets/img/NO_IMAGE.png";

class OrderItemTable extends Component {


    render() {
        let rowNo =0;
        return (
           <Fragment>
               <div className="web-view order-items-table">
                   <div className="row">
                       <div className="col-md-1">
                           <label></label>
                       </div>
                       <div className="col-md-2">
                           <label>項目</label>
                       </div>
                       <div className="col-md-2">
                           <label>項目名 </label>
                       </div>
                       <div className="col-md-2">
                           <label className="pull-right">
                               <FormattedMessage id="app.order.confirm.table.qty"
                                                 defaultMessage="Qty"
                                                 description=""/></label>
                       </div>
                       <div className="col-md-3">
                           <label className="pull-right">
                               <FormattedMessage id="app.order.confirm.table.sub-total"
                                                 defaultMessage="Sub Total"
                                                 description=""/>
                           </label>
                       </div>
                       <div className="col-md-2">
                           <label className="pull-right">
                               <FormattedMessage id="app.order.confirm.table.price"
                                                 defaultMessage="Price"
                                                 description=""/></label>
                       </div>
                   </div>
                   <div className="row">
                       <div className="col-md-12">
                           <hr />
                       </div>
                   </div>

                   {this.props.cartItems.map((item)=>{
                       rowNo += 1;
                       return(
                           <div key={item.id}>
                               <OrderItemRow rowNo={rowNo} item={item}/>
                               <div className="row">
                                   <div className="col-md-12">
                                       <hr />
                                   </div>
                               </div>
                           </div>
                       );

                   })}
               </div>
               <div className="mobile-view">
                   {this.props.cartItems.map((item)=>{
                       console.log("ITEMMMMMM ====> ", item);
                       return(
                           <div>
                              <div className="responsive-item-heading">
                                  アイテム -  {rowNo} - {item.itemName}
                              </div>
                               <div className="item-responsive-content">
                                   {item.reviewResult ?
                                <div className="custom-col-4">
                                    <img src={item.gerberDto.imageUrlTopEncoded} className="order-confirmation-image"/>
                                </div>
                               :
                                   <div className="custom-col-4">
                                       <img src={No_Image} className="order-confirmation-image"/>
                                   </div>
                               }
                                <div className="custom-col-6 order-item-tbl">
                                    <p>商品名 : {item.itemName}</p>
                                    <p>枚数 :
                                        {item.quotation.orderType === 1 &&
                                        <Fragment>PCB : {item.quotation.pcbParam.qty}</Fragment>
                                        }
                                        {item.quotation.orderType === 2 &&
                                        <Fragment>PCB : {item.quotation.pcbParam.qty}<br/>SMTメタルマスク : {item.quotation.stencilParam.stencilQty}</Fragment>
                                        }
                                        {item.quotation.orderType === 3 &&
                                        <Fragment>SMTメタルマスク: {item.quotation.stencilParam.stencilQty}</Fragment>
                                        }
                                    </p>
                                    <p>小計 :¥ <NumberFormatter num={item.chargeDetails.priceInfoJson}/></p>
                                    <p className="responsive-item-total-price">税込み価格 :¥ <NumberFormatter num={item.chargeDetails.totalPrice}/></p>
                                </div>
                               </div>
                           </div>
                       );

                   })}

               </div>
           </Fragment>
        )
    }
}

export default OrderItemTable;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderItemTable/OrderItemTable.js